import { useEffect } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { InspectionsOverviewPage } from './pages/InspectionsOverviewPage';
import { InspectionsListPage } from './pages/InspectionsListPage';
import { InspectionDetailPage } from './pages/InspectionDetailPage';
import { OrderDeviceDetailsPage } from './pages/OrderDeviceDetailsPage';
import { ReportsOverviewPage } from './pages/ReportsOverviewPage';
import { ProfilePage } from './pages/ProfilePage';
import { LoginPage } from './pages/LoginPage';
import { useTechnicianSessionStore } from './store/technicianSession';
import { isJwtExpired } from './utils/jwt';
import './styles/global.css';

const ProtectedLayout = () => {
  const isLoading = useTechnicianSessionStore((state) => state.isLoading);
  const token = useTechnicianSessionStore((state) => state.token);
  const clearSession = useTechnicianSessionStore((state) => state.clearSession);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      return;
    }

    if (isJwtExpired(token)) {
      void (async () => {
        await clearSession('Sitzung abgelaufen. Bitte erneut anmelden.');
        navigate('/login', {
          replace: true,
          state: {
            from: location
          }
        });
      })();
    }
  }, [token, clearSession, navigate, location]);

  if (isLoading) {
    return <div className="app-loader">Sitzung wird geladen …</div>;
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

export const App = () => {
  const initializeSession = useTechnicianSessionStore((state) => state.initializeSession);

  useEffect(() => {
    void initializeSession();
  }, [initializeSession]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<InspectionsOverviewPage />} />
        <Route path="/inspections" element={<InspectionsListPage />} />
        <Route path="/inspections/:orderId" element={<InspectionDetailPage />} />
        <Route path="/inspections/:orderId/devices/:deviceId" element={<OrderDeviceDetailsPage />} />
        <Route path="/reports" element={<ReportsOverviewPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
